var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 150,
    viewBox: "0 0 420 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.wave{\n    animation:waves 3s infinite ease-in-out;\n    transform-origin: 50% 48%;\n}\n.delay1{\n    animation-delay: 1s;\n}\n\n.delay2{\n    animation-delay: 2s;\n}\n@keyframes waves{\n    0%{\n        fill-opacity: 0;\n        transform: scale(0);\n    }\n    25%{\n        transform: scale(1);\n    }\n    50%{\n        fill-opacity:0.2;\n        transform: scale(1.5);\n    }\n    75%{\n        fill-opacity:0.1;\n        transform: scale(1.75);\n    }\n    100%{\n       fill-opacity: 0;\n       transform: scale(2);\n    }\n}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "wave",
    cx: 209,
    cy: 70,
    r: 36,
    fill: "#F47226"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "wave delay1",
    cx: 209,
    cy: 70,
    r: 36,
    fill: "#F47226"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "wave delay2",
    cx: 209,
    cy: 70,
    r: 36,
    fill: "#F47226"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 70,
    r: 36,
    fill: "#F47226"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 70,
    r: 4,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 70,
    r: 4,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.3
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 70,
    r: 6,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.65d2a859c8cd9c767329a89c31aebb37.svg";
export { ForwardRef as ReactComponent };